import cloneDeep from "lodash/cloneDeep";
import * as api from "../../api/documentsApi";
import type { DocumentType } from "../../types/documentType";
const DocumentListModel = {
  state: {
    isDocumentListLoading: false,
    total: 0,
    documentList: [] as Array<any>,
  },
  reducers: {
    addDocument(state: Record<string, any>, payload: DocumentType): any {
      let documentList = cloneDeep(state.documentList);
      let document = { ...payload };
      documentList.push(document);
      return { ...state, documentList: documentList };
    },

    updateDocumentList: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, documentList: payload.documentList };
    },
    setDocumentListTotal: (
      state: Record<string, any>,
      payload: number
    ): any => {
      return { ...state, total: payload };
    },

    setDocumentListRequest(state: Record<string, any>): any {
      return { ...state, isDocumentListLoading: true };
    },

    setDocumentListSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        documentList: payload.documentList,
        total: payload.total,
        isDocumentListLoading: false,
      };
    },

    purgeDocumentList: (state: Record<string, any>): any => {
      return { ...state, bookmarkList: [] };
    },
  },
  effects: {
    async setDocumentList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setDocumentListRequest();
      return api
        .getDocumentList()
        .then(resp => {
          if (resp.data !== undefined) {
            this.setDocumentListSuccess({
              documentList: resp.data,
              total: resp.data.length,
            });
          }
        })
        .catch(error => {
          this.setDocumentListSuccess({
            documentList: [],
            total: 0,
          });
          throw error;
        });
    },
  },
};
export default DocumentListModel;
